import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FrontEndContext from "../../context/FrontEndContext";
import Page from "../../components/Page";
import "./index.css";
//import axios, { AxiosError } from "axios"; //DM June 16 2025. This may still be used after we test in Prod.
//import config, { DisplayablePlantingData, ApiPlantingData, PlantingType, PLANTING_TYPE_NAMES, ApiPlantingDataPagination } from "../../config"; //DM June 16 2025. This may still be used after we test in Prod.
import { isTokenExpired, refreshBearerToken } from "../../services/auth";
import Select from 'react-select';
 //DM June 16 2025. This may still be used after we test in Prod.
import FieldLogListPagination from "../../components/FieldLogListPagination";
import LiveViewListPagination from "../../components/LiveViewListPagination";


const HEADER_NAME = "";

/*interface CompanyDropDown{
  value: string;
  label: string;
} *///DM June 16 2025. This may still be used after we test in Prod.

//const { SYSTEMS, API_FAIL_ERROR, } = config?.api;

const Home = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isAuthenticating, dataLoaded, headersWithAuth,  setBearerToken, systems, isAdmin} =
    React.useContext(FrontEndContext); //,

    type OptionType = {
      value: string;
      label: string;
    };

    /*const selectOptions: OptionsType<OptionType> = systems.map((s) => ({
      value: s.systemId,
      label: `${s.companyName} - ${s.systemName}`,
    })).sort((a, b) => a.label.localeCompare(b.label));*/

    const selectOptions = systems.map((s): OptionType => ({
  value: s.systemId,
  label: `${s.companyName} - ${s.systemName}`,
})).sort((a, b) => a.label.localeCompare(b.label));



    /*for(var x = 0; x < systems.length; ++x){
      selectOptions[x] = {value: systems[x].systemId, label: systems[x].companyName + " - " + systems[x].systemName};//Concat companyName to systemName for the label
    }
    selectOptions.sort((a, b) => a.label.localeCompare(b.label))*/
    
  //const [selectOptions, setSelectOptions] = useState<CompanyDropDown[]>();
  
  const [arraySystemIds, setArraySystemIds] = useState([""]);
  const [pageNumber, setPageNumber] = useState(0);
  const [companyChanged, setCompanyChanged] = useState(false);
  //const [selectedSystemName, setSelectedSystemName] = useState("");
  const [selectedOption, setSelectedOption] = useState<{ value: string; label: string } | null>(null);



  //***Should this be moved to the components?***
  useEffect(() => {
    if (!isAuthenticating && !isAuthenticated) {
      navigate("/login");      
    }
    
    const checkActiveToken = async () => {
      let currentToken = headersWithAuth?.headers?.Authorization.split(" ")[1] ?? "";
      let newToken = "";
      
      // Refresh the token if expired
      if (isTokenExpired(currentToken)) {
        newToken = await refreshBearerToken();
        if (newToken) {
          setBearerToken(newToken);
          currentToken = newToken;
        } else {
          navigate("/login");
          return;
        }
      }

      /*const updatedHeadersWithAuth = {
        headers: { Authorization: `Bearer ${newToken || currentToken}` },
      };*/
      
    };
    checkActiveToken();
   
    //DM Feb 17 2025. If Admin login don't reteive all logged plantings.
    /*if(isAdmin){//DM Aug 18 2025. C9^wcDcZ7$&H@FKb is not the only admin account. isAdmin is coming from user/info end point.
      setAdminLoggedIn(true);
    }*/

  }, [isAuthenticating, isAuthenticated, headersWithAuth, navigate, setBearerToken]);//,[systems, headersWithAuth, logPlantingDataRequested, activePlantingDataRequested,]


 useEffect(() => {
    const saved = sessionStorage.getItem('dropdownSelection');
    if (saved) {
      const matched = selectOptions.find((opt) => opt.value === saved);
      //if (matched) setSelectedOption(matched);
      if (matched) {
      handleChange(matched); // ✅ triggers full logic
    }

    }
  }, [selectOptions]);


  //DM June 16 2025. If we use admin drop down we will need these.
  const handleChange = (selectedOption: any) => {
    const newSystemID = selectedOption.value;
    //setArraySystemIds([...arraySystemIds, newSystemID]);
    setArraySystemIds([newSystemID]);
    setPageNumber(1);
    setCompanyChanged(true);
    setSelectedOption(selectedOption);
    sessionStorage.setItem('dropdownSelection', selectedOption.value);
  }

  //let selectOptions = [];
  if(isAdmin){//replaced adminLoggedIn
    
    for(var x = 0; x < systems.length; ++x){
      if(systems[x].systemName !== null){
        //selectOptions[x] = {value: systems[x].systemId, label: systems[x].companyName + " - " + systems[x].systemName};//Concat companyName to systemName for the label
        selectOptions[x] = {value: systems[x].systemId, label: systems[x].systemName};//Concat companyName to systemName for the label
      }
    }
    selectOptions.sort((a, b) => a.label.localeCompare(b.label))
  }
  console.log("Dataloaded value:" + dataLoaded);
  //DM Aug 11 2025. When you were on the second page of a company and switched to a company that only had one page no records were shown. This is used to 
  //identify that a new company was selected and to allow for multiple page scrolling.
  const resetCompanyChanged = () => {
    setCompanyChanged(false);
  };


  return (//DM April 15 2024. Added hideAlarmButton={true} to hide Alarm History button for release. Remove hideAlarmButton={true} when ready to release Alarm History
    <Page name={HEADER_NAME} isAuthenticating={isAuthenticating} hideAlarmButton={false}>
      <div className="home-container">
        <div className="live-view-container py-3">
          <LiveViewListPagination/>
        </div>
        {isAdmin ?(
              <div style={{paddingBottom: "15px"}}>
                <Select
                 value={selectedOption}
                   options={selectOptions as readonly OptionType[]}
                  onChange={handleChange}
                   
                   />
             </div>
        ):(null)}
        {isAdmin ?(
          <div className="field-log-container">
            <FieldLogListPagination
              passedSystemIds={arraySystemIds}
              passedCompanyChanged={companyChanged}
              onFinishedLoading={resetCompanyChanged}
            />
          </div>
          ):(<div className="field-log-container">
              <FieldLogListPagination/>
            </div>)
         }
      </div>
    </Page>
  );
};

export default Home;


